import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

interface Step {
  label: string;
  description: string;
}

const DEFAULT_STEPS: Step[] = [
  { label: "Foto", description: "Enviar e recortar" },
  { label: "Categoria", description: "Escolher contexto" },
  { label: "Tipo", description: "Gratuito ou pago" },
  { label: "Público", description: "Público-alvo" },
  { label: "Revisar", description: "Confirmar detalhes" },
];

interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
  steps?: Step[];
}

export function StepIndicator({
  currentStep,
  totalSteps,
  steps,
}: StepIndicatorProps) {
  const displaySteps = (steps ?? DEFAULT_STEPS).slice(0, totalSteps);

  return (
    <div className="flex justify-center p-4">
      <div className="flex items-center">
        {displaySteps.map((step, index) => {
          const stepNum = index + 1;
          const isActive = currentStep === stepNum;
          const isCompleted = currentStep > stepNum;
          return (
            <div key={step.label} className="flex items-center">
              <div className="flex flex-col items-center">
                <div
                  className={cn(
                    "flex h-8 w-8 items-center justify-center rounded-full border-2 text-sm font-semibold transition-colors sm:h-10 sm:w-10",
                    isCompleted
                      ? "border-emerald-500 bg-emerald-500/20 text-emerald-300"
                      : isActive
                        ? "border-primary bg-primary/20 text-primary"
                        : "border-border bg-muted text-muted-foreground",
                  )}
                >
                  {isCompleted ? <Check size={18} /> : stepNum}
                </div>
                <span
                  className={cn(
                    "mt-2 hidden text-xs font-medium sm:block",
                    isActive ? "text-foreground" : "text-muted-foreground",
                  )}
                >
                  {step.label}
                </span>
              </div>
              {index < totalSteps - 1 && (
                <div
                  className={cn(
                    "mx-2 h-0.5 w-8 sm:mx-3 sm:w-16",
                    currentStep > stepNum ? "bg-emerald-500/50" : "bg-border",
                  )}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
